// Rellenar con keys de traducciones.

export enum MainStatusCodes {
    PendingPayment = 'PQ',
    NoBankComunication = 'RP',
    DeniedPayment = 'N',
    SyncPayment = 'M',
    FraudControl = 'F',
    Confirmed = 'A',
    InWarehouseE = 'E',
    InWarehouseG = 'G',
    InssuficientInventory = 'L',
    Canceled = 'X',
    SendedR = 'R',
    SendedS = 'S',
    InCarrierD = 'D',
    InCarrier = 'U',
    ReadyToPick = 'U',
    Rejected = 'T',
    Delivered = 'K',
}

export enum StatusWording {
    PendingPayment = 'dev.myOrders.status.pendingPayment',
    DeniedPayment = 'dev.myOrders.status.deniedPayment',
    Confirmed = 'dev.myOrders.status.confirmed',
    InWarehouse = 'dev.myOrders.status.inWarehouse',
    Canceled = 'dev.myOrders.status.canceled',
    Sended = 'dev.myOrders.status.sended',
    InCarrier = 'dev.myOrders.status.InCarrier',
    ReadyToPick = 'dev.myOrders.status.readyToPick',
    Rejected = 'dev.myOrders.status.rejected',
    Delivered = 'dev.myOrders.status.delivered',
}
